module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-item",
    attrs: {
      "status": _vm.status
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "item-icon"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#icon-' + _vm.fileIcon
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('h6', {
    attrs: {
      "title": _vm.file.name
    }
  }, [_vm._v("\n        " + _vm._s(_vm.file.name) + "\n      ")]), _vm._v(" "), _c('p', {
    attrs: {
      "title": _vm.file.father
    }
  }, [_vm._v("\n        " + _vm._s(_vm.showText) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item-bit"
  }, [_vm._v("\n      " + _vm._s(_vm.formatedSize) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "item-speed"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status !== 'uploading'),
      expression: "status !== 'uploading'"
    }],
    attrs: {
      "id": 'unique-id1-' + _vm.file.id
    }
  }, [_vm._v(_vm._s(_vm.statusText))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status === 'uploading'),
      expression: "status === 'uploading'"
    }]
  }, [_vm._v(_vm._s(_vm.formatedAverageSpeed))])]), _vm._v(" "), _c('div', {
    staticClass: "item-status"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalcHash === false && _vm.status === 'uploading'),
      expression: "isCalcHash === false && status === 'uploading'"
    }],
    staticClass: "start act",
    attrs: {
      "title": "暂停"
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('i', {
    staticClass: "iconfont icon-status-start"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalcHash === false && _vm.status === 'paused'),
      expression: "isCalcHash === false && status === 'paused'"
    }],
    staticClass: "start",
    class: {
      'pauseDisabled': !_vm.showPaused
    },
    attrs: {
      "title": "开始"
    },
    on: {
      "click": _vm.resume
    }
  }, [_c('i', {
    staticClass: "iconfont  icon-status-start"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalcHash === false && _vm.status === 'error'),
      expression: "isCalcHash === false && status === 'error'"
    }],
    staticClass: "again",
    attrs: {
      "title": "重试",
      "id": 'unique-id3-' + _vm.file.id
    },
    on: {
      "click": _vm.retry
    }
  }, [_c('i', {
    staticClass: "iconfont icon-status-again"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalcHash === false && _vm.status === 'success'),
      expression: "isCalcHash === false && status === 'success'"
    }],
    staticStyle: {
      "color": "#00c15c"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-status-processing",
    attrs: {
      "id": 'unique-id2-' + _vm.file.id
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalcHash === false && _vm.status != 'success'),
      expression: "isCalcHash === false && status != 'success'"
    }],
    staticClass: "delete",
    attrs: {
      "title": "删除"
    },
    on: {
      "click": _vm.remove
    }
  }, [_c('i', {
    staticClass: "iconfont icon-status-fail"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.isCalcHash && _vm.isCalcHash !== false) || _vm.isCalcHash === true),
      expression: "(!isCalcHash && isCalcHash !== false) || isCalcHash === true"
    }],
    staticClass: "calc",
    attrs: {
      "title": "正在计算文件大小...",
      "id": 'unique-id4-' + _vm.file.id
    }
  }, [_c('i', {
    staticClass: "iconfont icon-status-processing"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress",
    style: (_vm.progressStyle)
  })], {
    "file": _vm.file,
    "list": _vm.list,
    "status": _vm.status,
    "paused": _vm.paused,
    "error": _vm.error,
    "response": _vm.response,
    "averageSpeed": _vm.averageSpeed,
    "formatedAverageSpeed": _vm.formatedAverageSpeed,
    "currentSpeed": _vm.currentSpeed,
    "isComplete": _vm.isComplete,
    "isUploading": _vm.isUploading,
    "size": _vm.size,
    "formatedSize": _vm.formatedSize,
    "uploadedSize": _vm.uploadedSize,
    "progress": _vm.progress,
    "progressStyle": _vm.progressStyle,
    "progressingClass": _vm.progressingClass,
    "timeRemaining": _vm.timeRemaining,
    "formatedTimeRemaining": _vm.formatedTimeRemaining,
    "type": _vm.type,
    "extension": _vm.extension,
    "fileCategory": _vm.fileCategory,
    "fileIcon": _vm.fileIcon
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66ec03fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file.vue
// module id = 76
// module chunks = 0